// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formLoaderBackground {
    position: fixed;
    top: 0;
    opacity: 0.7;
    background-color: #000000;
    width: 100vw;
    height: 100vh;
    z-index: 1;
}

.formLoaderDiv {
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background: transparent;
    text-align: center;
}

.formLoaderLogo {
    max-height: 4rem;
    object-fit: contain;
    animation: heartbeat 1.5s ease-in-out infinite both;
  }
  
.formLoaderTxt {
    margin-top: 1rem;
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2rem;
}

/* Safari */

@keyframes heartbeat {
    0% {
        transform: scale(1);
        transform-origin: center center;
        animation-timing-function: ease-out;
    }
    10% {
        transform: scale(.91);
        animation-timing-function: ease-in;
    }
    17% {
        transform: scale(.98);
        animation-timing-function: ease-out;
    }
    33% {
        transform: scale(.87);
        animation-timing-function: ease-in;
    }
    45% {
        transform: scale(1);
        animation-timing-function: ease-out;
    }
}


    `, "",{"version":3,"sources":["webpack://./src/components/fields/formLoader/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mDAAmD;EACrD;;AAEF;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,WAAW;;AAyBX;IACI;QACI,mBAAmB;QACnB,+BAA+B;QAC/B,mCAAmC;IACvC;IACA;QACI,qBAAqB;QACrB,kCAAkC;IACtC;IACA;QACI,qBAAqB;QACrB,mCAAmC;IACvC;IACA;QACI,qBAAqB;QACrB,kCAAkC;IACtC;IACA;QACI,mBAAmB;QACnB,mCAAmC;IACvC;AACJ","sourcesContent":[".formLoaderBackground {\n    position: fixed;\n    top: 0;\n    opacity: 0.7;\n    background-color: #000000;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1;\n}\n\n.formLoaderDiv {\n    position: fixed;\n    z-index: 1;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    background: transparent;\n    text-align: center;\n}\n\n.formLoaderLogo {\n    max-height: 4rem;\n    object-fit: contain;\n    animation: heartbeat 1.5s ease-in-out infinite both;\n  }\n  \n.formLoaderTxt {\n    margin-top: 1rem;\n    color: #ffffff;\n    font-size: 1.25rem;\n    font-weight: 500;\n    line-height: 1.2rem;\n}\n\n/* Safari */\n@-webkit-keyframes heartbeat {\n    0% {\n        -webkit-transform: scale(1);\n        -webkit-transform-origin: center center;\n        animation-timing-function: ease-out;\n    }\n    10% {\n        -webkit-transform: scale(.91);\n        animation-timing-function: ease-in;\n    }\n    17% {\n        -webkit-transform: scale(.98);\n        animation-timing-function: ease-out;\n    }\n    33% {\n        -webkit-transform: scale(.87);\n        animation-timing-function: ease-in;\n    }\n    45% {\n        -webkit-transform: scale(1);\n        animation-timing-function: ease-out;\n    }    \n}\n\n@keyframes heartbeat {\n    0% {\n        transform: scale(1);\n        transform-origin: center center;\n        animation-timing-function: ease-out;\n    }\n    10% {\n        transform: scale(.91);\n        animation-timing-function: ease-in;\n    }\n    17% {\n        transform: scale(.98);\n        animation-timing-function: ease-out;\n    }\n    33% {\n        transform: scale(.87);\n        animation-timing-function: ease-in;\n    }\n    45% {\n        transform: scale(1);\n        animation-timing-function: ease-out;\n    }\n}\n\n\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
